import styled from 'styled-components';
import BackButton from '../utils/back_button';
import { blog6 } from "../../../assets/images";
import { useNavigate } from 'react-router-dom';
import OtherBlogs from '../our_blogs/OtherBlogs';
import CTASection from "../../landing/landing_home/empower"



const BlogPost = () => {
      const navigate = useNavigate();
      const handleBackClick = () => {
         window.scrollTo(0, 0);
         navigate("/blog")
      };
  const beforeAfterData = [
    ['Financial aid confusion', 'Wait days for a callback', 'Chatbot provides instant, tailored info'],
    ['Course planning', 'Email advisor, wait a week', 'AI analyzes transcript, suggests steps'],
    ['Finding study space', 'Visit help desk', 'AI gives live availability via Chatbot'],
    ['Registration hold', 'Call office, leave voicemail', 'Instant diagnosis and solution steps']
  ];

  const beforeAfterHeaders = ['Scenario', 'Traditional Support', 'AI-Powered Support'];

  const realWorldData = [
    ['Academics', 'Course planning, assignment nudges, transcript analysis'],
    ['Financial Aid', 'Status checks, form help, proactive deadline alerts'],
    ['Admin Support', 'Registration help, ID issues, campus navigation']
  ];

  const realWorldHeaders = ['Area', 'AI Features in Action'];

  return (
     <>
      <Fullpage>
       <PageBackground>
        <BlogContainer>
         <MainContent>
          <HeaderSection>
           <BackButtonContainer>
            <BackButton onClick={handleBackClick}>
              Back to Blogs
            </BackButton>
           </BackButtonContainer>
           <BlogHeader />
          </HeaderSection>

          <BlogImage
            src={blog6}
            alt="AI-powered campus support illustration"
          />

          <ArticleContent>
          <IntroText>
            A staggering 73% of college students report feeling overwhelmed at least once a week (National College Health Assessment, 2025). The modern campus experience is more demanding than ever, with students navigating academic deadlines, financial pressures, social anxieties, and uncertain career paths—all while seeking real-time support that traditional systems such as FAQs and simple Chatbots often fail to provide.
          </IntroText>

          <ContentSection title="The New Reality: Student Stress at an All-Time High">
            <BodyText>
              Recent headlines and studies confirm what many on campus already feel: student anxiety and depression rates are at record levels, with academic pressure, financial strain, and social isolation as leading causes. Chronic stress doesn't just impact grades—it threatens mental health, physical well-being, and long-term prospects, sometimes pushing students toward burnout or dropping out.
            </BodyText>
            <BodyText>
              Traditional support structures, such as admins and counsellors have limited office hours with long waiting lists, that simply can't keep up with the scale and urgency of today's student needs. The result? Many students feel alone, insecure, unheard, and unsupported when it matters most.
            </BodyText>
          </ContentSection>

          <ContentSection title="The AI Shift: Always-On, Multi-Channel Student Support">
            <SubheadingText>
              AI-powered student support platforms such as "Campus Insights" are rapidly changing this landscape, offering:
            </SubheadingText>
            <BulletList>
              <li>24/7 availability across web, mobile, chat, text, voice, and email</li>
              <li>Instant, personalized answers to complex questions</li>
              <li>Proactive outreach based on student behavior and risk signals</li>
              <li>Seamless transitions between channels—no more repeating information</li>
            </BulletList>
            <BodyText>
              Instead of waiting hours and days for help, students can now get immediate, non-judgmental support—whether it's late-night exam stress or a quick question about campus resources.
            </BodyText>
          </ContentSection>

          <ContentSection title="Before & After: The AI Advantage">
            <ComparisonTable data={beforeAfterData} headers={beforeAfterHeaders} />
          </ContentSection>

          <ContentSection title="Meeting Students Where They Are: Multi-Platform, Seamless Support">
            <SubheadingText>
              Today's students are digital natives, switching between devices and platforms throughout the day. AI tools meet them wherever they are:
            </SubheadingText>
            <BulletList>
              <li>Campus website chatbots for instant answers</li>
              <li>SMS/text updates for deadlines and reminders</li>
              <li>Mobile apps with push notifications and location-aware help</li>
              <li>Voice assistants for hands-free guidance</li>
              <li>Social media DMs for quick resource links</li>
            </BulletList>
            <BodyText>
              This continuity builds trust and reduces frustration—students don't have to repeat themselves or start over every time they switch channels. Mobile integration is especially powerful, as AI-based Chatbots can deliver location-specific support, like dining hall menus or study room availability, exactly when and where it's needed.
            </BodyText>
          </ContentSection>

          <ContentSection title="Personalization: Tailoring Support to Every Student">
            <PersonalizationImage
              src="https://api.builder.io/api/v1/image/assets/TEMP/5769e9de115d2b4794ef8fed634ee95c28af86bd?width=1526"
              alt="Personalized AI support interface"
            />
            <SubheadingText>
              AI's most transformative feature is its ability to deliver personalized support. By analyzing academic records, behavioral patterns, and communication preferences, AI systems can:
            </SubheadingText>
            <BulletList>
              <li>Suggest resources and strategies tailored to each student's major, year, and learning style</li>
              <li>Offer mental health tips based on stress patterns and preferred formats (visual, written, audio)</li>
              <li>Provide financial aid reminders and guidance specific to individual circumstances</li>
              <li>Adapt communication style—some students prefer emails, others texts from their favorite platform</li>
            </BulletList>
            <BodyText>
              This level of personalization ensures that every student receives the right help, at the right time, in the way that works best for them12.
            </BodyText>
          </ContentSection>

          <ContentSection title="Real-World Impact: AI in Action on Campus">
            <ComparisonTable data={realWorldData} headers={realWorldHeaders} />
            <BodyText>
              Campuses adopting AI report higher student satisfaction, faster response times, and improved retention rates.
            </BodyText>
          </ContentSection>

          <ContentSection title="Balancing Privacy and the Human Touch">
            <SubheadingText>
              AI isn't replacing human support—it's amplifying it. Systems are designed to:
            </SubheadingText>
            <BulletList>
              <li>Anonymize data and follow strict privacy protocols</li>
              <li>Escalate complex or sensitive cases to trained experts</li>
              <li>Let AI handle routine queries, freeing humans for empathetic, high-stakes support</li>
            </BulletList>
          </ContentSection>

          <ContentSection title="What's Next: The Future of AI Student Support">
            <SubheadingText>
              Emerging trends in campus AI can include:
            </SubheadingText>
            <BulletList>
              <li>Predictive alerts to prevent dropouts before they happen</li>
              <li>Voice and AR-powered support for immersive, hands-free help</li>
              <li>Emotion-aware AI that adapts in real time to student mood</li>
              <li>AI-driven communities connecting students with shared experiences</li>
            </BulletList>
          </ContentSection>

          <ContentSection title="Conclusion: A Supported Student Is a Successful Student">
            <BodyText>
              As stress and complexity rise on campus, AI-powered support is moving student services from reactive to proactive, and from isolated to truly connected. Help is no longer a hallway away—it's already in every student's pocket.
            </BodyText>
            <BodyText>
              With the right blend of technology and human empathy, campuses can ensure every student has the support they need to thrive—not just academically, but in every aspect of college life, helping them to achieve the success they seek.
            </BodyText>
          </ContentSection>
        </ArticleContent>
      </MainContent>
    </BlogContainer>
    <OtherBlogs currentBlogId={6} />
    </PageBackground>
    </Fullpage>
    <CTASection />
  </>
  );
};

const BlogHeader = () => {
  return (
    <HeaderContainer>
      <Title>
        From Stress to Success: How AI-Powered Support Eases Campus Pressure
      </Title>
      <MetaInfo>
        <DateText>Augudt 5, 2025</DateText>
        <AuthorText>posted by campus insights</AuthorText>
      </MetaInfo>
    </HeaderContainer>
  );
};

const ComparisonTable = ({ data, headers }) => {
  return (
    <TableWrapper>
      <Table>
        <HeaderRow>
          {headers.map((header, index) => (
            <HeaderCell key={index}>
              <CellContent>
                <HeaderText>{header}</HeaderText>
              </CellContent>
            </HeaderCell>
          ))}
        </HeaderRow>
        {data.map((row, rowIndex) => (
          <DataRow key={rowIndex}>
            {row.map((cell, cellIndex) => (
              <DataCell key={cellIndex}>
                <CellContent>
                  <CellText>{cell}</CellText>
                </CellContent>
              </DataCell>
            ))}
          </DataRow>
        ))}
      </Table>
    </TableWrapper>
  );
};

const ContentSection = ({ title, children, className }) => {
  return (
    <SectionContainer className={className}>
      {title && <SectionTitle>{title}</SectionTitle>}
      <ContentWrapper>{children}</ContentWrapper>
    </SectionContainer>
  );
};

const BlogImage = ({ src, alt, className }) => {
  return (
    <ImageContainer className={className}>
      <Image src={src} alt={alt} />
    </ImageContainer>
  );
};

const ImageContainer = styled.figure`
  width: 100%;
  margin: 0;
`;

const Image = styled.img`
  width: 100%;
  height: 400px;
  border-radius: 16px;
  object-fit: cover;

  @media (max-width: 991px) {
    height: 300px;
  }

  @media (max-width: 640px) {
    height: 250px;
  }
`;


const SectionContainer = styled.section`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
`;

const SectionTitle = styled.h2`
  color: #1c1b1f;
  letter-spacing: -0.32px;
  width: 100%;
  font: 700 32px/120% Inter, sans-serif;
  margin: 0;

  @media (max-width: 991px) {
    font-size: 28px;
    line-height: 120%;
  }

  @media (max-width: 640px) {
    font-size: 24px;
    line-height: 120%;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
`;


const TableWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;

  @media (max-width: 640px) {
    overflow-x: auto;
  }
`;

const Table = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 4px;
  border: 1px solid #5b5b5b;
  background-color: #fff;

  @media (max-width: 991px) {
    overflow-x: auto;
  }

  @media (max-width: 640px) {
    min-width: 500px;
  }
`;

const HeaderRow = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;
  background-color: rgba(255, 255, 255, 0);

  @media (max-width: 991px) {
    min-width: 600px;
  }
`;

const DataRow = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;
  background-color: rgba(255, 255, 255, 0);

  @media (max-width: 991px) {
    min-width: 600px;
  }
`;

const HeaderCell = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;
  height: 100%;
  border-top: 1px solid #5b5b5b;
  border-left: 1px solid #5b5b5b;
  background-color: rgba(255, 255, 255, 0.05);
`;

const DataCell = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;
  height: 100%;
  border-top: 1px solid #5b5b5b;
  border-left: 1px solid #5b5b5b;
  background-color: rgba(255, 255, 255, 0);
`;

const CellContent = styled.div`
  display: flex;
  padding: 10px 12px;
  align-items: flex-start;
  width: 100%;
`;

const HeaderText = styled.span`
  color: #1c1b1f;
  letter-spacing: -0.2px;
  flex: 1 0 0;
  font: 500 20px/140% Inter, sans-serif;

  @media (max-width: 640px) {
    font-size: 16px;
  }
`;

const CellText = styled.span`
  flex: 1 0 0;
  color: #64636a;
  letter-spacing: -0.08px;
  font: 500 16px/160% Inter, sans-serif;

  @media (max-width: 640px) {
    font-size: 14px;
  }
`;

const HeaderContainer = styled.header`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  width: 100%;
`;

const Title = styled.h1`
  width: 100%;
  color: #1c1b1f;
  letter-spacing: -0.48px;
  font: 700 48px/120% Inter, sans-serif;
  margin: 0;

  @media (max-width: 991px) {
    font-size: 36px;
    line-height: 120%;
  }

  @media (max-width: 640px) {
    font-size: 28px;
    line-height: 120%;
  }
`;

const MetaInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
`;

const DateText = styled.time`
  color: #64636a;
  letter-spacing: 2px;
  text-transform: uppercase;
  font: 400 16px/120% Inter, sans-serif;

  @media (max-width: 640px) {
    font-size: 14px;
  }
`;

const AuthorText = styled.span`
  color: #64636a;
  letter-spacing: 2px;
  text-transform: uppercase;
  font: 500 16px/120% Inter, sans-serif;

  @media (max-width: 640px) {
    font-size: 14px;
  }
`;

const BlogContainer = styled.div`
  display: flex;
  width: 100%;
  max-width: 1120px;
  padding: 56px;
  flex-direction: column;
  align-items: flex-start;
  gap: 64px;
  border-radius: 24px;
  margin: 0 auto;
  box-sizing: border-box;
  background-color: #fff;

  @media (max-width: 991px) {
    padding: 40px;
    gap: 48px;
  }

  @media (max-width: 640px) {
    padding: 24px;
    gap: 32px;
  }
`;

const MainContent = styled.main`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 42px;
  width: 100%;
`;

const HeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
  width: 100%;
`;

const ArticleContent = styled.article`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  width: 100%;
`;

const IntroText = styled.p`
  width: 100%;
  color: #64636a;
  letter-spacing: -0.08px;
  font: 500 16px/160% Inter, sans-serif;
  margin: 0;
`;

const SubheadingText = styled.p`
  color: #64636a;
  letter-spacing: -0.2px;
  width: 100%;
  font: 500 20px/140% Inter, sans-serif;
  margin: 0;

  @media (max-width: 640px) {
    font-size: 18px;
  }
`;

const BodyText = styled.p`
  width: 100%;
  color: #64636a;
  letter-spacing: -0.08px;
  font: 500 16px/160% Inter, sans-serif;
  margin: 0;
`;

const BulletList = styled.ul`
  width: 100%;
  color: #64636a;
  letter-spacing: -0.08px;
  font: 500 16px/160% Inter, sans-serif;
  margin: 0;
  padding-left: 20px;

  li {
    margin-bottom: 8px;
  }
`;

const PersonalizationImage = styled(BlogImage)`
  max-width: 763px;
  margin-bottom: 16px;
`;

const PageBackground = styled.div`
  height: 100%;
  width: 100%;
  background: linear-gradient(to bottom, #5e2bff 0px, #5e2bff 500px, #F5F5F9 100px, #F5F5F9 100%);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 200px 0;
    flex-direction: column;

  @media (max-width: 640px) {
    padding: 40px 0;
    background: linear-gradient(to bottom, #5e2bff 0px, #5e2bff 100px, #ffffff 100px, #ffffff 100%);
  }
`;

const Fullpage = styled.div`
  height: 100%;
  width: 100%;
//   background-color: #e20707ff;
  display: flex;
  justify-content: center;
  align-items: flex-start;
 

  @media (max-width: 640px) {
    padding: 40px 0;
   
  }
`;

const BackButtonContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  gap: 16px;
`;

export default BlogPost;
